/**
 * JWT Token Utilities
 *
 * Provides functions to check token expiration.
 * Used to distinguish between expired tokens (should logout) and
 * permission-based 401 errors (should not logout).
 */

import jwtDecode from "jwt-decode";

/**
 * Check if a JWT token is expired
 * @param {string} token - The JWT token to check
 * @returns {boolean} True if expired or invalid, false if still valid
 */
export const isTokenExpired = (token) => {
  if (!token || typeof token !== "string") {
    return true;
  }

  try {
    const payload = jwtDecode(token);

    if (typeof payload.exp !== "number") {
      // No exp claim, treat as expired for safety
      return true;
    }

    // exp is in seconds, Date.now() is in milliseconds
    const currentTime = Math.floor(Date.now() / 1000);

    return payload.exp <= currentTime;
  } catch (error) {
    console.error("Failed to decode JWT:", error);
    return true;
  }
};
